import React from 'react';

import ArticleGallery from 'components/ArticleGallery';

import { Wrapper } from './WidgetGallery.style';

function WidgetGallery({ title = '', data = [] }) {
  return (
    <Wrapper>
      <ArticleGallery title={title} images={data} />
    </Wrapper>
  );
}

export default WidgetGallery;
